export default "__VITE_ASSET__C3D0LA3P__"